import React from "react";
import HistoryDataSidebar from "components/shared/history-data-sidebar";
import { useFleetHistory } from "../hooks/useFleetHistory";

interface DetailHistorySidebarProps {
  id: string;
  isOpen: boolean;
  onClose: () => void;
  detail?: any;
}

const DetailHistorySidebar: React.FC<DetailHistorySidebarProps> = ({
  id,
  isOpen,
  onClose,
  detail,
}) => {
  const {
    sidebarItems,
    summaryItems,
    isLoading,
    isLoadingMore,
    hasMore,
    loadMore,
    startDate,
    endDate,
    setDateRange,
    searchValue,
    setSearchValue,
  } = useFleetHistory(id, isOpen, detail);

  return (
    <HistoryDataSidebar
      open={isOpen}
      onClose={onClose}
      summaryItems={summaryItems}
      items={sidebarItems}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      fromDateValue={startDate}
      toDateValue={endDate}
      onDateChange={setDateRange}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={loadMore}
      emptyTitle={isLoading ? "Loading history..." : undefined}
    />
  );
};

export default DetailHistorySidebar;
